<script setup lang="ts">
import done from '@/assets/icons/done.svg';
import { storeToRefs } from 'pinia';
import { useKycSessionStore } from '@/stores/kycSession.store';
import KycSessionLayout from '@/layout/KycSessionLayout.vue';

const kycSessionStore = useKycSessionStore();
const { kycSession } = storeToRefs(kycSessionStore);

const partnerName = kycSession?.value?.partner?.name ?? 'Immersve';
const kycRedirectURL = kycSession?.value?.redirectUrl;
</script>

<template>
  <KycSessionLayout>
    <div class="flex flex-col" data-test="screen-kyc-done">
      <img :src="done" class="mb-8 size-16" />
      <h1 class="mb-6 text-3xl">You're all done!</h1>

      <p class="text-light-secondary dark:text-dark-secondary mb-8">
        Your application has been approved.
      </p>

      <p v-if="kycRedirectURL" class="text-light-primary dark:text-dark-primary mb-6 font-bold">
        Go back to
        <a data-test="action-back-to-partner" :href="kycRedirectURL" class="underline">{{
          partnerName
        }}</a>
        to continue.
      </p>
    </div>
  </KycSessionLayout>
</template>
